import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CalendarDaysIcon, LayoutTemplateIcon, ShoppingCartIcon, BookOpenIcon, ClipboardListIcon, ShieldCheckIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-warm py-16 md:py-24" ref={ref} data-id="element-279">
      <div className="max-w-prose mx-auto px-5" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-281">
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-sage mb-4" data-id="element-282">
            Qué obtienes exactamente
          </p>

          <h2 className="font-sans font-bold text-2xl md:text-3xl text-charcoal mb-4 leading-tight" data-id="element-283">
            Dentro del PDF vas a encontrar:
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-5 mt-8" data-id="element-284">
          <div className="flex items-start gap-4" data-id="element-285">
            <div className="w-9 h-9 rounded-lg bg-terracotta/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-286">
              <CalendarDaysIcon className="w-4.5 h-4.5 text-terracotta" data-id="element-287" />
            </div>
            <div data-id="element-288">
              <p className="font-sans font-semibold text-charcoal" data-id="element-289">
                Plan de 14 días
              </p>
              <p className="font-serif text-base text-charcoal/70 leading-relaxed" data-id="element-290">
                Estructura moderada: 3 comidas + 1 snack. Sin extremos.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-291">
            <div className="w-9 h-9 rounded-lg bg-sage/15 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-292">
              <LayoutTemplateIcon className="w-4.5 h-4.5 text-sage" data-id="element-293" />
            </div>
            <div data-id="element-294">
              <p className="font-sans font-semibold text-charcoal" data-id="element-295">
                Menús por plantillas
              </p>
              <p className="font-serif text-base text-charcoal/70 leading-relaxed" data-id="element-296">
                Para no cocinar distinto cada día. Repite lo que funciona.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-297">
            <div className="w-9 h-9 rounded-lg bg-gold/15 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-298">
              <ShoppingCartIcon className="w-4.5 h-4.5 text-gold" data-id="element-299" />
            </div>
            <div data-id="element-300">
              <p className="font-sans font-semibold text-charcoal" data-id="element-301">
                Lista de compras (USA)
              </p>
              <p className="font-serif text-base text-charcoal/70 leading-relaxed" data-id="element-302">
                + prep de 60 min para 3–4 días. Un solo viaje al super.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-303">
            <div className="w-9 h-9 rounded-lg bg-terracotta/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-304">
              <BookOpenIcon className="w-4.5 h-4.5 text-terracotta" data-id="element-305" />
            </div>
            <div data-id="element-306">
              <p className="font-sans font-semibold text-charcoal" data-id="element-307">
                Reglas claras
              </p>
              <p className="font-serif text-base text-charcoal/70 leading-relaxed" data-id="element-308">
                Para cena, café, agua y combinaciones. Sin ambigüedad.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-309">
            <div className="w-9 h-9 rounded-lg bg-sage/15 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-310">
              <ClipboardListIcon className="w-4.5 h-4.5 text-sage" data-id="element-311" />
            </div>
            <div data-id="element-312">
              <p className="font-sans font-semibold text-charcoal" data-id="element-313">
                Trackers imprimibles
              </p>
              <p className="font-serif text-base text-charcoal/70 leading-relaxed" data-id="element-314">
                Para que al día 14 tengas tu{' '}
                <strong data-id="element-315">protocolo de 1 página</strong>.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-316">
            <div className="w-9 h-9 rounded-lg bg-gold/15 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-317">
              <ShieldCheckIcon className="w-4.5 h-4.5 text-gold" data-id="element-318" />
            </div>
            <div data-id="element-319">
              <p className="font-sans font-semibold text-charcoal" data-id="element-320">
                Plan anti-rebote
              </p>
              <p className="font-serif text-base text-charcoal/70 leading-relaxed" data-id="element-321">
                Para fines de semana y días sociales. Sin culpa.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}